import { useState, useEffect } from "react";
import { supabase } from "../../supabase";

export default function CategoryEditor({ catId, label, icon, items, onSave }) {
  const [collapsed, setCollapsed] = useState(true);
  const [list,      setList]      = useState(items);
  const [input,     setInput]     = useState("");
  const [saving,    setSaving]    = useState(false);
  const [saved,     setSaved]     = useState(false);

  useEffect(() => { setList(items); }, [items]);

  const hasChanges = JSON.stringify(list) !== JSON.stringify(items);

  function addItem() {
    const trimmed = input.trim();
    if (!trimmed || list.includes(trimmed)) return;
    setList(prev => [...prev, trimmed]);
    setInput("");
    setSaved(false);
  }

  function removeItem(item) {
    setList(prev => prev.filter(i => i !== item));
    setSaved(false);
  }

  async function save() {
    setSaving(true);
    const { error } = await supabase
      .from("settings")
      .upsert({ key: `items_${catId}`, value: list }, { onConflict: "key" });
    setSaving(false);
    if (error) { alert("Error al guardar: " + error.message); return; }
    setSaved(true);
    onSave(list);
  }

  return (
    <div className="card" style={{ marginBottom: 8 }}>
      <button
        onClick={() => setCollapsed(c => !c)}
        style={{ width: "100%", background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", padding: 0 }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, letterSpacing: 2, textTransform: "uppercase", color: "#666" }}>
          {icon} {label}
          {hasChanges && (
            <span style={{ fontSize: 10, color: "#cc2200", letterSpacing: 0, textTransform: "none" }}>● sin guardar</span>
          )}
        </span>
        <span style={{ color: "#444", fontSize: 11 }}>{collapsed ? "▾" : "▴"}</span>
      </button>

      {!collapsed && (
        <div style={{ marginTop: 16 }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 7, marginBottom: 16, minHeight: 32 }}>
            {list.map(item => (
              <span key={item} style={{
                display: "flex", alignItems: "center", gap: 6,
                background: "#1a1a1a", border: "1px solid #2a2a2a",
                borderRadius: 4, fontSize: 12, padding: "5px 10px", color: "#ccc",
              }}>
                {item}
                <button
                  onClick={() => removeItem(item)}
                  style={{ background: "none", border: "none", color: "#444", cursor: "pointer", padding: 0, lineHeight: 1, display: "flex", transition: "color 0.15s" }}
                  onMouseEnter={e => e.currentTarget.style.color = "#cc2200"}
                  onMouseLeave={e => e.currentTarget.style.color = "#444"}
                >
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </span>
            ))}
          </div>
          <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
            <input
              className="input"
              placeholder={`Añadir ${label.toLowerCase()}...`}
              value={input}
              onChange={e => { setInput(e.target.value); setSaved(false); }}
              onKeyDown={e => e.key === "Enter" && addItem()}
              style={{ flex: 1 }}
            />
            <button className="btn-ghost" onClick={addItem} style={{ flexShrink: 0 }}>+ Añadir</button>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button className="btn-primary" onClick={save} disabled={saving || !hasChanges}>
              {saving ? "Guardando..." : "Guardar cambios"}
            </button>
            {saved && !hasChanges && <span style={{ fontSize: 12, color: "#00e676" }}>✓ Guardado</span>}
          </div>
        </div>
      )}
    </div>
  );
}
